import React, { useState, useEffect } from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaEdit,
  FaUser,
  FaUserPlus,
  FaCheckCircle,
  FaTimes,
  FaArrowLeft,
  FaSpinner,
  FaTrash,
  FaClock,
  FaWhatsapp,
} from "react-icons/fa";
import { toast } from "react-toastify";
import axios from "axios";
import { useSelector } from "react-redux";
import { Customerdetaildrawer } from "../../../components/Customerdetaildrawer/Customerdetaildrawer";
import { SecondaryUserDrawer } from "../../../components/Customerdetaildrawer/SecondaryUserDrawer";
import { useProfile } from "../../../context/ProfileContext";
import config from "../../../config";

export const Profilesectionpage = () => {
  const API_BASE_URL = config.API_BASE_URL;
  const auth = useSelector((state) => state.auth || {});
  //const { phone } = auth || {};
  const { phone, isSecondaryUser: isSecUser, secondaryUserInfo } = auth || {};
  const token = localStorage.getItem("token");

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSecondaryDrawerOpen, setIsSecondaryDrawerOpen] = useState(false);
  const [isSecondaryUserModalOpen, setIsSecondaryUserModalOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [secondaryUsers, setSecondaryUsers] = useState([]);
  const [selectedSecondaryUser, setSelectedSecondaryUser] = useState(null);
  
  // Form states with address fields
  const [formData, setFormData] = useState({
    phone: '',
    otp: '',
    name: '',
    email: '',
    street: '',
    landmark: '',
    city: '',
    state: '',
    pincode: ''
  });
  
  const [errors, setErrors] = useState({});

  const { customerDetails, loader, updateCustomer, refetchCustomer } = useProfile();

  useEffect(() => {
    if (customerDetails && customerDetails.secondaryUsers) {
      setSecondaryUsers(customerDetails.secondaryUsers);
    }
  }, [customerDetails]);
  
  const handleUpdateCustomer = async (updatedData) => {
    try {
      const result = await updateCustomer(updatedData);
      if (result) {
        toast.success("Customer details updated successfully!");
        setIsDrawerOpen(false);
      } else {
        toast.error("Failed to update customer details.");
      }
    } catch (e) {
      toast.error("Something went wrong!");
    }
  };

  // Update Secondary User (with phone change support)
  // Update Secondary User (with phone change support)
const handleUpdateSecondaryUser = async (secondaryUserId, updatedData, newPhone, otp) => {
  if (!secondaryUserId) {
    toast.error("Invalid user ID");
    return false;
  }

  setLoading(true);
  try {
    let payload;

    const address = {
      street: updatedData.address?.street || '',
      landmark: updatedData.address?.landmark || '',
      city: updatedData.address?.city || '',
      state: updatedData.address?.state || '',
      pincode: updatedData.address?.pincode || ''
    };

    if (newPhone && newPhone !== updatedData.phone) {
      if (!otp) {
        toast.error("OTP is required to verify new phone number");
        return false;
      }

      payload = {
        name: updatedData.name,
        email: updatedData.email,
        newPhone: newPhone,
        otp: otp,
        address: address
      };
    } else {
      payload = {
        name: updatedData.name,
        email: updatedData.email,
        address: address
      };
    }

    const response = await axios.put(
      `${API_BASE_URL}/customer/updatesecondaryuser/${secondaryUserId}`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (response.data.status) {
      await refetchCustomer();
      toast.success('Secondary user updated successfully!');
      return true;
    } else {
      toast.error(response.data.message || 'Failed to update secondary user');
      return false;
    }
  } catch (error) {
    console.error('Update Secondary User Error:', error);
    toast.error(error.response?.data?.message || 'Network error. Please try again.');
    return false;
  } finally {
    setLoading(false);
  }
};

  // Send OTP for phone update
  const sendPhoneUpdateOTP = async (secondaryUserId, newPhone) => {
    if (!newPhone || newPhone.length !== 10) {
      toast.error("Please enter a valid 10-digit phone number");
      return false;
    }

    setLoading(true);
    try {
      const payload = {
        phone: newPhone,
        isUpdate: true,
        secondaryUserId: secondaryUserId
      };

      const response = await axios.post(
        `${API_BASE_URL}/customer/sendsecondaryotp`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      if (response.data.status) {
        toast.success('OTP sent successfully!');
        return true;
      } else {
        toast.error(response.data.message || 'Failed to send OTP');
        return false;
      }
    } catch (error) {
      toast.error('Network error. Please try again.');
      return false;
    } finally {
      setLoading(false);
    }
  };

  // Delete Secondary User
  const handleDeleteSecondaryUser = async (secondaryUserId, userName) => {
    if (!secondaryUserId) {
      toast.error("Invalid user ID");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/customer/deletesecondaryuser/${secondaryUserId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      const data = response.data;
      if (data.status) {
        await refetchCustomer();
        toast.success(`${userName} removed successfully!`);
      } else {
        toast.error(data.message || 'Failed to remove secondary user');
      }
    } catch (error) {
      console.error('Delete Secondary User Error:', error);
      toast.error(error.response?.data?.message || 'Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Open edit drawer for secondary user
  const openEditDrawer = (user) => {
    setSelectedSecondaryUser(user);
    setIsSecondaryDrawerOpen(true);
  };

  const resetForm = () => {
    setFormData({ 
      phone: '', 
      otp: '', 
      name: '', 
      email: '',
      street: '',
      landmark: '',
      city: '',
      state: '',
      pincode: ''
    });
    setStep(1);
    setErrors({});
  };

  const handleCloseModal = () => {
    resetForm();
    setIsSecondaryUserModalOpen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  // Send OTP for add
  const handleSendOTP = async () => {
    if (!formData.phone || formData.phone.length !== 10) {
      setErrors({ phone: 'Please enter a valid 10-digit phone number' });
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${API_BASE_URL}/customer/sendsecondaryotp`,
        { phone: formData.phone },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      const data = res.data;
      if (data.status) {
        setStep(2);
        toast.success('OTP sent successfully!');
      } else {
        toast.error(data.message || 'Failed to send OTP');
      }
    } catch (error) {
      toast.error('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Add Secondary User with Address
  const handleAddSecondaryUser = async () => {
    const newErrors = {};
    if (!formData.otp) newErrors.otp = 'OTP is required';
    //if (!formData.name) newErrors.name = 'Name is required';
   // if (!formData.email) newErrors.email = 'Email is required';
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    try {
      const payload = {
        phone: formData.phone,
        otp: formData.otp,
        name: formData.name,
        email: formData.email,
        address: {
          street: formData.street || '',
          landmark: formData.landmark || '',
          city: formData.city || '',
          state: formData.state || '',
          pincode: formData.pincode || ''
        }
      };

      const res = await axios.post(
        `${API_BASE_URL}/customer/addsecondaryuser`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      const data = res.data;
      if (data.status) {
        await refetchCustomer();
        resetForm();
        setIsSecondaryUserModalOpen(false);
        toast.success('Secondary user added successfully!');
      } else {
        toast.error(data.message || 'Failed to add secondary user');
      }
    } catch (error) {
      toast.error('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loader || !customerDetails) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <div className="animate-spin h-12 w-12 border-t-4 border-orange-500 mb-4"></div>
        <p className="text-gray-600">Loading profile...</p>
      </div>
    );
  }

  const fullName = `${customerDetails.firstname || customerDetails.firstName || ""} ${
    customerDetails.lastname || customerDetails.lastName || ""
  }`.trim();

  return (
    <div className="min-h-screen  bg-gray-50">
    <div className="max-w-7xl mx-auto px-2 sm:px-4 md:px-6 py-3 md:py-8">
      {/* Profile Header */}
      <div className="bg-white rounded-xl md:rounded-2xl shadow-sm border border-gray-100 p-5 md:p-8 mb-2 md:mb-4">
        <div className="flex flex-col md:flex-row items-center md:items-start gap-3 md:gap-6">
          <div className="w-14 h-14 md:w-20 md:h-20 bg-gradient-to-br from-orange-500 to-amber-600 rounded-xl md:rounded-2xl flex items-center justify-center text-white shadow-md">
            {fullName ? (
              <span className="text-2xl md:text-4xl font-semibold">
                {fullName.charAt(0).toUpperCase()}
              </span>
            ) : (
              <FaUser className="text-2xl md:text-5xl" />
            )}
          </div>
          <div className="flex-1 text-center md:text-left">
            <h1 className="text-xl md:text-3xl font-bold text-gray-900 mb-0.5 md:mb-1">
              {fullName || "User"}
            </h1>
            <div className="space-y-1">
            {/* Email */}
             {customerDetails.email && customerDetails.email.trim() !== "" && (
            <div className="flex items-center gap-2 text-gray-700 text-sm sm:text-base md:text-lg lg:text-xl">
              <FaEnvelope className="text-blue-500 shrink-0" />
              <span className="truncate">
                {customerDetails.email || ""}
              </span>
            </div>
            )}

            {/* Phone */}
            {customerDetails.contact && (
              <div className="text-gray-700 text-sm sm:text-base md:text-lg lg:text-xl font-medium">
                {customerDetails.whatsapp && customerDetails.whatsapp === customerDetails.contact ? (
                  // Case 1: Same number - Show both icons with single number
                  <div className="flex items-center gap-2">
                    <FaPhoneAlt className="text-gray-700 shrink-0" />
                    <FaWhatsapp className="text-green-500 shrink-0" />
                    <span>+91 {customerDetails.contact}</span>
                  </div>
                ) : (
                  // Case 2: Different numbers - Show separate lines
                  <div className="space-y-1">
                    <div className="flex items-center gap-2">
                      <FaPhoneAlt className="text-gray-700 shrink-0" />
                      <span>+91 {customerDetails.contact}</span>
                    </div>
                    {customerDetails.whatsapp && (
                      <div className="flex items-center gap-2">
                        <FaWhatsapp className="text-green-500 shrink-0" />
                        <span>+91 {customerDetails.whatsapp}</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
          {/*<button
            onClick={() => setIsDrawerOpen(true)}
            className="w-full md:w-auto flex items-center justify-center gap-2 px-5 py-2.5 bg-orange-600 hover:bg-orange-700 text-white text-base md:text-base font-semibold rounded-xl md:rounded-2xl transition-all duration-200 shadow-md active:scale-95 mt-1 md:mt-0"
          >
            <FaEdit className="text-lg" />
            <span>Edit Profile</span>
          </button>*/}
          <button
          onClick={() => setIsDrawerOpen(true)}
          disabled={isSecUser}
          className={`w-full md:w-auto flex items-center justify-center gap-2 px-5 py-2.5 text-white text-base md:text-base font-semibold rounded-xl md:rounded-2xl transition-all duration-200 shadow-md active:scale-95 mt-1 md:mt-0 ${
            isSecUser 
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-orange-600 hover:bg-orange-700'
          }`}
        >
          <FaEdit className="text-lg" />
          <span>Edit Profile</span>
        </button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 md:gap-6 mb-2">
        {/* Address Information */}
        <div className="lg:col-span-5">
          <div className="bg-white rounded-2xl md:rounded-3xl shadow-sm border border-gray-100 p-5 md:p-8 h-full">
            <div className="flex items-center gap-3 mb-4 md:mb-4">
              <div className="w-10 h-10 md:w-10 md:h-10 bg-orange-100 rounded-lg md:rounded-2xl flex items-center justify-center">
                <FaMapMarkerAlt className="text-orange-600 text-lg md:text-2xl" />
              </div>
              <h2 className="text-lg md:text-2xl font-semibold text-gray-900">Address</h2>
            </div>

            {customerDetails?.address ? (
              <div className="max-w-3xl">
                <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-700 leading-snug md:leading-relaxed tracking-tight">
                  {[
                    customerDetails.address.street,
                    customerDetails.address.landmark,
                    customerDetails.address.city,
                    customerDetails.address.state,
                    customerDetails.address.zip
                  ]
                    .filter(Boolean)
                    .join(" ")}
                </p>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-10 md:h-64 text-center">
                <FaMapMarkerAlt className="text-4xl md:text-6xl text-gray-200 mb-3" />
                <p className="text-gray-400 text-sm md:text-base font-medium">No address added yet</p>
                <p className="text-xs text-gray-400 mt-1">Click "Edit Profile" to add your address</p>
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* Secondary Users Section */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-3 md:p-8 lg:p-8">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-3">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 lg:w-14 lg:h-14 bg-orange-100 rounded-xl flex items-center justify-center shrink-0">
              <FaUserPlus className="text-orange-600 text-4xl" />
            </div>
            <div>
              <h2 className="text-xl sm:text-2xl lg:text-2xl font-semibold text-gray-900">
                Linked Account
              </h2>
            </div>
          </div>

          {secondaryUsers.length === 0 && (
            <button
              onClick={() => setIsSecondaryUserModalOpen(true)}
              className="w-full sm:w-auto flex items-center justify-center gap-2 px-5 py-2.5 bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white text-sm font-medium rounded-xl transition-all duration-200 shadow-sm hover:shadow-md"
            >
              <FaUserPlus className="text-lg" />
              Add Member
            </button>
          )}
        </div>

        {/* Users Grid */}
        {secondaryUsers.length > 0 ? (
          <div className="grid grid-cols-1 gap-2">
            {secondaryUsers.map((user) => (
              <div
                key={user._id}
                className="group flex flex-col justify-between bg-white border border-gray-200 rounded-xl p-4 hover:shadow-md transition-all duration-300 hover:border-orange-200 min-h-[160px]"
              >
                {/* Top Row */}
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-amber-500 rounded-lg flex items-center justify-center text-white font-semibold text-2xl capitalize">
                      {user.name.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 sm:text-base md:text-lg lg:text-xl leading-tight capitalize">
                        {user.name || "Secondary User"}
                      </h3>
                      <p className="text-base text-blue-600">Secondary User</p>
                    </div>
                  </div>
                  <div className="p-1.5 flex gap-10 transition">
                    <button
                      onClick={() => openEditDrawer(user)}
                      className="hidden md:flex items-center justify-center gap-2 px-5 py-2.5 bg-orange-600 hover:bg-orange-600 text-white text-lg md:text-base font-semibold rounded-xl transition-all duration-200 shadow-md"
                    >
                      <FaEdit className="text-lg" />
                      <span>Edit User</span>
                    </button>
                     {!isSecUser && (
                    <button
                      onClick={() => handleDeleteSecondaryUser(user._id, user.name)}
                      className="p-1.5 rounded-md hover:bg-gray-100 text-blue-500 hover:text-red-600"
                    >
                      <FaTrash className="w-4 h-4 md:w-6 md:h-6 lg:w-8 lg:h-8" />
                    </button>
                     )}
                  </div>
                </div>

                {/* Info */}
                <div className="space-y-2 text-sm sm:text-base md:text-lg lg:text-xl text-gray-700 mb-3">
                  <div className="flex items-center gap-2 truncate">
                    <FaPhoneAlt classNaume="text-sm sm:text-base md:text-lg lg:text-xl text-gray-800 shrink-0" />
                    <span className="text-sm sm:text-base md:text-lg lg:text-xl">+91 {user.phone}</span>
                  </div>
                   {user.email && (
                  <div className="flex items-center gap-2 truncate mb-4">
                    <FaEnvelope className="text-sm sm:text-base md:text-lg lg:text-xl text-blue-600 shrink-0" />
                    <span className="text-sm sm:text-base md:text-lg lg:text-xl">{user.email}</span>
                  </div>
                   )}
                  {/* Display Address if exists */}
                  {user.address && (user.address.street || user.address.city) && (
                    <div className="flex items-start gap-2 truncate">
                      <FaMapMarkerAlt className="sm:text-base md:text-lg shrink-0 mt-0.5" />
                      <span className="sm:text-base md:text-lg lg:text-xl text-gray-600 " >
                        {[user.address.street, user.address.landmark, user.address.city, user.address.state, user.address.pincode]
                          .filter(Boolean)
                          .join(", ")}
                      </span>
                    </div>
                  )}
                </div>
                
                <div className="md:hidden">
                  <button
                    onClick={() => openEditDrawer(user)}
                    className="w-full flex items-center justify-center gap-2 px-5 py-2.5 bg-orange-600 hover:bg-orange-700 text-white text-base font-semibold rounded-xl transition-all duration-200 shadow-md"
                  >
                    <FaEdit className="text-lg" />
                    <span>Edit User</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          /* Empty State */
          <div className="text-center py-10 sm:py-14">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <FaUserPlus className="text-2xl sm:text-3xl text-gray-400" />
            </div>
            <p className="text-gray-600 font-medium text-sm sm:text-base">No linked accounts yet</p>
            <p className="text-xs sm:text-sm text-gray-400 mt-1">Add members to manage bookings and profiles easily</p>
            <button
              onClick={() => setIsSecondaryUserModalOpen(true)}
              className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 bg-orange-500 hover:bg-orange-600 text-white text-sm font-medium rounded-lg shadow-sm"
            >
              <FaUserPlus />
              Add Member
            </button>
          </div>
        )}
      </div>

      {/* Add Secondary User Modal with Address Fields */}
      {isSecondaryUserModalOpen && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4">
            <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={handleCloseModal}></div>
            
            <div className="relative bg-white rounded-2xl max-w-md w-full mx-auto shadow-xl transform transition-all max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between p-6 border-b border-gray-200 sticky top-0 bg-white z-10">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-orange-100 rounded-xl flex items-center justify-center">
                    <FaUserPlus className="text-orange-600 text-xl" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900">
                      {step === 1 ? "Add Family Member" : "Verify & Add"}
                    </h3>
                    <p className="text-sm text-gray-500">
                      {step === 1 ? "Enter phone number to verify" : "Enter OTP and details"}
                    </p>
                  </div>
                </div>
                <button onClick={handleCloseModal} className="text-gray-400 hover:text-gray-600 transition-colors">
                  <FaTimes className="text-xl" />
                </button>
              </div>

              <div className="p-6">
                {step === 1 ? (
                  <div className="space-y-6">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Phone Number <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <FaPhoneAlt className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          placeholder="Enter 10-digit mobile number"
                          maxLength="10"
                          className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all"
                        />
                      </div>
                      {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
                      <p className="text-xs text-gray-500 mt-2">We'll send a 4-digit OTP to verify this number</p>
                    </div>
                    <button
                      onClick={handleSendOTP}
                      disabled={loading}
                      className="w-full py-3 bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white font-semibold rounded-xl transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {loading ? (
                        <span className="flex items-center justify-center gap-2">
                          <FaSpinner className="animate-spin" />
                          Sending OTP...
                        </span>
                      ) : (
                        "Send OTP"
                      )}
                    </button>
                  </div>
                ) : (
                  <div className="space-y-5">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        OTP <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="otp"
                        value={formData.otp}
                        onChange={handleInputChange}
                        placeholder="Enter 4-digit OTP"
                        maxLength="4"
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all"
                      />
                      {errors.otp && <p className="text-red-500 text-xs mt-1">{errors.otp}</p>}
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Full Name
                      </label>
                      <div className="relative">
                        <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          placeholder="Enter full name"
                          className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all"
                        />
                      </div>
                      {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Email Address 
                      </label>
                      <div className="relative">
                        <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder="Enter email address"
                          className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all"
                        />
                      </div>
                      {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                    </div>

                    {/* Address Fields */}
                    <div className="border-t border-gray-200 pt-4">
                      <p className="text-sm font-semibold text-gray-700 mb-3">Address (Optional)</p>
                      <div className="space-y-3">
                        <input
                          type="text"
                          name="street"
                          value={formData.street}
                          onChange={handleInputChange}
                          placeholder="Street address"
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all"
                        />
                        <input
                          type="text"
                          name="landmark"
                          value={formData.landmark}
                          onChange={handleInputChange}
                          placeholder="Landmark"
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all"
                        />
                        <div className="grid grid-cols-2 gap-3">
                          <input
                            type="text"
                            name="city"
                            value={formData.city}
                            onChange={handleInputChange}
                            placeholder="City"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all"
                          />
                          <input
                            type="text"
                            name="state"
                            value={formData.state}
                            onChange={handleInputChange}
                            placeholder="State"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all"
                          />
                        </div>
                        <input
                          type="text"
                          name="pincode"
                          value={formData.pincode}
                          onChange={handleInputChange}
                          placeholder="Pincode"
                          maxLength="6"
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all"
                        />
                      </div>
                    </div>

                    <div className="flex gap-3 pt-2">
                      <button onClick={() => setStep(1)} className="flex-1 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 transition-all">
                        <span className="flex items-center justify-center gap-2"><FaArrowLeft className="text-sm" />Back</span>
                      </button>
                      <button onClick={handleAddSecondaryUser} disabled={loading} className="flex-1 py-3 bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white font-semibold rounded-xl transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-50">
                        {loading ? <span className="flex items-center justify-center gap-2"><FaSpinner className="animate-spin" />Adding...</span> : "Add Member"}
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div className="p-6 border-t border-gray-200 bg-gray-50 rounded-b-2xl">
                <div className="flex justify-between items-center">
                  <div className="flex gap-1">
                    <div className={`h-1.5 w-8 rounded-full transition-all ${step === 1 ? 'bg-orange-500' : 'bg-gray-300'}`}></div>
                    <div className={`h-1.5 w-8 rounded-full transition-all ${step === 2 ? 'bg-orange-500' : 'bg-gray-300'}`}></div>
                  </div>
                  <p className="text-xs text-gray-500">{step === 1 ? "Step 1 of 2" : "Step 2 of 2"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Secondary User Edit Drawer */}
      <SecondaryUserDrawer
        isOpen={isSecondaryDrawerOpen}
        onClose={() => setIsSecondaryDrawerOpen(false)}
        userData={selectedSecondaryUser}
        token={token}
        onUpdate={handleUpdateSecondaryUser}
        onSendOTP={sendPhoneUpdateOTP}
      />

      {/* Customer Edit Drawer */}
      <Customerdetaildrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        customerData={customerDetails}
        token={token}
        onUpdate={handleUpdateCustomer}
        phone={phone}
      />
    </div>
    </div>
  );
};